var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"route-title",rawName:"v-route-title",value:('欢迎页面'),expression:"'欢迎页面'"}]},[(_vm.showDefaultPage)?_c('h3',[_vm._v("欢迎使用"+_vm._s(_vm.projectName))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }